
// function to format an iso date string to Month Day, Year, in the es-DO locale, i.e. Septiembre 4, 2023
const dateWithMonthName = (isoDateString?: string, defaultValue?: string): string => {
  if (!isoDateString) return defaultValue || '';
  const date = new Date(isoDateString);
  return date.toLocaleDateString('es', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

// function to format an ISO date string to a readable date and time format
const formatDateTime = (isoDateString?: string, defaultValue?: string): string => {
  if (!isoDateString) return defaultValue || '';
  const hasTimeZone = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(isoDateString);
  const normalizedDateString = hasTimeZone ? isoDateString : `${isoDateString}Z`;
  const date = new Date(normalizedDateString);
  const formatted = date.toLocaleString('es', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
  return formatted.replace(/\ba\. m\./i, 'am').replace(/\bp\. m\./i, 'pm');
}

export {
  dateWithMonthName,
  formatDateTime
}
